/**
 * Created by sungho.hong on 2019-06-03.
 */
import Vue from "vue";
export const EventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/common/event-bus.js